import React from 'react'
import PropTypes from 'prop-types'
import { compose, withContext } from 'recompose'
import { withContextRouter } from './utils/withRouter'
import { withAssets } from './utils/withAssets'
import ContextElementSwitcher from './ContextElementSwitcher'

const BluePrintRenderer = compose(
  withContext(
    { elementById: PropTypes.object },
    ({ bluePrint: { elementById } }) => ({ elementById }),
  ),
  withContextRouter(),
  withAssets(),
)(
  ({
    api,
    bluePrint,
    className,
  }) => {
    if (!bluePrint || !bluePrint.details) {
      return null
    }
    return (
      <div className={`blueprint-renderer ${className}`}>
        {bluePrint.details.map((elementId) => (
          <ContextElementSwitcher
            key={elementId}
            api={api}
            elementId={elementId}
            EnhancedSwitcher={ContextElementSwitcher}
          />
        ))}
      </div>
    )
  }
)

BluePrintRenderer.propTypes = {
  bluePrint: PropTypes.shape({
    details: PropTypes.array.isRequired,
    elementById: PropTypes.object.isRequired
  }).isRequired,
  router: PropTypes.object,
  assets: PropTypes.object.isRequired,
  api: PropTypes.object.isRequired,
}

BluePrintRenderer.defaultProps = {
  router: null
}

export default BluePrintRenderer



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/BluePrintRenderer.js